<template>
	<div ref="mainBody" class="mainBody" v-show="!isLoading">
		<!-- <van-sticky :offset-top="0"> -->
			<div class="navbar">
				<div class="h100 dFlex alCenter jcBetween" style="max-width: 1200px;margin: 0 auto;overflow:hidden;">
					<div class="logo dFlex alCenter">
						<van-image
						  width="150px"
						  height="150px"
						  fit="cover"
						  :src="logo"
						/>
						<!-- <span class="ml-3">Cosmo Engine Technology Co.，Limited</span> -->
					</div>
					<div class="navbarList">
						<ul class="dFlex alCenter">
							<li :class="{'active':current=='/home'}">
								<router-link to="/home">首页</router-link>
							</li>
							<li :class="{'active':current=='/about'}">
								<router-link to="/about">關於我們</router-link>
							</li>
							<li :class="{'active':current=='/contact'}">
								<router-link to="/contact">聯繫我們</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		<!-- </van-sticky> -->
		<AppMain />
		<div class="footers">
			<div class="pcMaxW secPadding">
				<van-row>
					
				  <van-col span="24">
					  <div class="jc">
						<van-image
						  width="280px"
						  height="160px"
						  fit="cover"
						  :src="logo"
						/>
					  </div>
				  </van-col>
					<van-col span="24">
					  <div class="jc mt-5">
					  	<a href="/about">About Us</a>
					  	&nbsp; · &nbsp;
					  	<a href="/clauseService">Privacy Policy</a>
					  	&nbsp; · &nbsp;
					  	<a href="#">Terms &amp; Conditions</a>
					  </div>
					</van-col>
					<van-col span="24">
						<p class="textCenter mt-5">Copyright © {{ $t('footer.company') }} 2025</p>
					</van-col>
				</van-row>
			</div>
			
		</div>
		<!-- <div class="footer">
			<div class="pcMaxW dFlex jcBetween pt-0 pb-5">
				<p class="">Copyright © {{ $t('footer.company') }} 2025</p>
				<div>
					<a href="/about" class="textSecondary">About Us</a>
					&nbsp; · &nbsp;
					<a href="/clauseService" class="textSecondary">Privacy Policy</a>
					&nbsp; · &nbsp;
					<a href="#" class="textSecondary">Terms &amp; Conditions</a>
				</div>
			</div>
		</div> -->
	</div>
	<van-popup v-model:show="isLoading" round :style="{ padding: '20px' }">{{ $t('common.loading') }}</van-popup>
</template>

<script setup>
import { ref,reactive,inject,defineAsyncComponent,onMounted,getCurrentInstance,watch,computed } from 'vue'
import { useRoute,useRouter,onBeforeRouteUpdate } from 'vue-router'
import { useI18n } from "vue-i18n"

const AppMain = defineAsyncComponent(() => import("./components/AppMain.vue"));

const { proxy } = getCurrentInstance();

const route = useRoute();
const router = useRouter();
const current = ref(route.meta.activeMenu);
const isLoading = ref(false)
const logo = ref(require('@/assets/images/logo.png'))
onBeforeRouteUpdate((to) => {
	current.value = to.meta.activeMenu;
	console.log(current.value)
});

onMounted(()=>{
	
})

const { locale } = useI18n();
const changeLang = () => {
	let lang = locale.value == 'kr' ? 'zh' : 'kr';
	locale.value = lang;
	reload()
}

</script>

<style lang="less" scoped>
	.mainBody{
		width: 100%;
		.navbar{
			width: 90%;
			max-width: 1480px;height: 86px;padding: 0;box-sizing: border-box;
			position: absolute;top: 50px;left: 50%;z-index: 11;transform: translate(-50%,0);
			background: #081624;
			box-shadow: 0 0 9px 3px rgba(226, 30, 228, 0.24);
			// &::before{
			// 	content: "";
			// 	  position: absolute;
			// 	  top: 0;left: 0;right: 0;bottom: 0;
			// 	  background: linear-gradient(to top, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.50) 100%);
			// 	  backdrop-filter: blur(6px);
			// 	  z-index: -1; /* 确保模糊层在内容之下 */
			// }
			.logo{
				img{
					vertical-align: middle;
				}
				span{
					color: rgba(255,255,255,0.8);
				}
			}
			.navbarList{
				padding-right: 20px;
				ul{
					li{
						cursor: pointer;
						padding-left: 10px;
						padding-right: 10px;
						a{
							display: block;position: relative;
							font-weight: 700;
							font-size: 14px;
							text-transform: capitalize;
							color: #fff;
							-webkit-transition: all 0.3s ease 0s;
							-moz-transition: all 0.3s ease 0s;
							-o-transition: all 0.3s ease 0s;
							transition: all 0.3s ease 0s;
							border: transparent;
							padding: 13px 10px;
							border-radius: 18px;
							letter-spacing: .3px;
							// &::before,&::after{
							// 	position: absolute;
							// 	    left: 0;
							// 	    width: 100%;
							// 	    height: 2px;
							// 	    background: #2C2A59;
							// 	    content: '';
							// 	    opacity: 0;
							// 	    -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
							// 	    -moz-transition: opacity 0.3s, -moz-transform 0.3s;
							// 	    transition: opacity 0.3s, transform 0.3s;
							// }
							// &::before{
							// 	top: 0;
							// 	-webkit-transform: translateY(-10px);
							// 	-moz-transform: translateY(-10px);
							// 	transform: translateY(-10px);
							// }
							// &::after{
							// 	bottom: 0;
							// 	-webkit-transform: translateY(10px);
							// 	-moz-transform: translateY(10px);
							// 	transform: translateY(10px);
							// }
							&:hover{
								color: #821FC7;
								&::before,&::after{
									-webkit-transform: translateY(0px);
									-moz-transform: translateY(0px);
									transform: translateY(0px);
									opacity: 1;
								}
							}
						}
						&.active{
							a{
								&::before,&::after{
									-webkit-transform: translateY(0px);
									-moz-transform: translateY(0px);
									transform: translateY(0px);
									opacity: 1;
								}
							}
						}
					}
					li + li{
						margin-left: 0.5rem;
					}
				}
			}
		}
		.footers{
			background: linear-gradient(to right, #330d38 0%, #190d36 100%);color: #9b91a6;
			.jc{
				display: flex;align-items: center;justify-content: center;
			}
			
					/deep/ a{
						color: #fff!important;line-height: 1.2;
						    font-size: 16px;
						    font-weight: 500;
						    color: #fff;
						&:hover{
							color: #821FC7;
							// opacity: unset;
						}
					}
				
		}
		
	}
</style>